import { getTimeString } from '../../../Utils';

const DelayedStopName = ({ classes, stopData, statusClass, status }) => {
  return (
    <div className={classes.delayedStop}>
      <div className={classes.detailContainer}>
        <div>
          {`${stopData.stopType} | ${getTimeString(stopData.arrivalTime)} - ${getTimeString(
            stopData.departureTime
          )}`}
        </div>
        <div className={`${classes.stopStatus} ${statusClass}`}>{status}</div>
      </div>
    </div>
  );
};

export default DelayedStopName;
